import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { AuthService } from '../../../../core/services/auth/auth.service';
import { WelcomeImageComponent } from '../../../components/welcome-image/welcome-image.component';
import { ToastService } from '../../../../core/services/toast.service';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    TranslateModule,
    WelcomeImageComponent,
  ],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss',
})
export class ForgotPasswordComponent {
  forgotPasswordForm = {
    email: '',
    selectedLanguageCode: 'en-US',
  };

  loading: boolean = false;

  constructor(
    private router: Router,
    private authService: AuthService,
    private translate: TranslateService,
    private toastService: ToastService
  ) {
    const userLang = localStorage.getItem('app-lang') || 'en-US';
    this.translate.use(userLang);
    this.forgotPasswordForm.selectedLanguageCode = userLang;
  }

  isValidEmail(): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(this.forgotPasswordForm.email);
  }

  submitForgotPassword(e: Event): void {
    e.preventDefault();

    if (!this.isValidEmail()) {
      return;
    }

    this.loading = true;

    const request = { email: this.forgotPasswordForm.email };

    this.authService.forgotPassword(request).subscribe({
      next: (response) => {
        this.loading = false;
        if (!response || !response.fail) {
          this.toastService.showToast(
            this.translate.instant('forgotPassword.eMailSendSuccessful'),
            'success'
          );
          setTimeout(() => {
            this.router.navigate(['/auth/login']);
          }, 2000);
        }
      },
      error: (err) => {
        this.loading = false;
        console.error('Forgot password error:', err);
      },
    });
  }
}
